exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".annunciator-message[data-v-8c32b1f2] {\n  white-space: pre-wrap;\n}", ""]);

// exports
